export const formatPrice = (price: any) => {
	if (!price && price !== 0) return '-'
	return Number(price).toFixed(2)
}

export const formatPriceCurrencyPrepend = (price: any, currency: string = 'PLN') =>
	// PLN 12.00
	`${currency} ${formatPrice(price)}`

export const formatPriceCurrencyAppend = (price: any, currency: string = 'zł') =>
	// 12.00 zł
	`${formatPrice(price)} ${currency}`

export const dividePrice = (price: any) => (price || price === 0 ? price / 100 : null)

export const multiplyPrice = (price: any) => (price || price === 0 ? price * 100 : null)

export const formatPriceGlobal = (price: number, currency: string = 'zł') => {
	const formattedPrice = (price / 100).toFixed(2)
	return `${formattedPrice} ${currency}`
}

export const PriceToShow = (price: string | number | null) => (price ? Number(price) / 100 : null)

export const PriceToPayload = (price: string) => Number(price) * 100
